import { useQuery } from "react-query";
import API from "../../axios/API";
import { QUERY_KEYS } from "../keys";
import { GET_ENDPOINTS } from "@/axios/API/endpoints";

const getStatesByCountry = async (countryCode) => {
  const { data } = await API.get(
    `${GET_ENDPOINTS.STATE_BY_COUNTRY}${countryCode}`,
  );
  return data.states;
};

const useStatesByCountry = (countryCode) =>
  useQuery([QUERY_KEYS.STATES, countryCode], () =>
    countryCode ? getStatesByCountry(countryCode) : null,
  );

export default useStatesByCountry;
